module.exports = __webpack_public_path__ + "static/media/infoIcon.80b96d49.svg";